import { BaseService } from "./base.service";

class MemberWhitelistService extends BaseService {
  constructor() {
    super("/member-whitelist");
  }

  async checkEmailWhitelist(email: string): Promise<boolean> {
    return await this.get<boolean>(`/email/${email}`);
  }

  async checkMobileWhitelist(mobile: string): Promise<boolean> {
    return await this.get<boolean>(`/mobile/${mobile}`);
  }
}

export const memberWhitelistService = new MemberWhitelistService();
